import { type MaybeRefOrGetter, toValue } from "vue";

import i18n from "@/plugins/i18n";
import { RouteStatus } from "@/constants/trip";

import type { TripRouteDto } from "@/api/trips/dto/trip.dto";
import type { DisableRule } from "@/types/validation";

const t = i18n.global.t;

export function useReplaceTruck() {
  function createReplaceTruckDisableRules(route: MaybeRefOrGetter<TripRouteDto>): DisableRule[] {
    const { status, dispatchConfirmed } = toValue(route);

    if (status === RouteStatus.cancelled) {
      return [
        {
          disabled: true,
          reasons: [t("trucks.replace-truck-route-cancelled")],
        },
      ];
    }
    return [
      {
        disabled: Boolean(dispatchConfirmed),
        reasons: [t("trucks.replace-truck-disabled")],
      },
    ];
  }

  return {
    createReplaceTruckDisableRules,
  };
}
